import { RootState } from '../rootReducer';

export const selectPaymentsState = (state: RootState) => state.payments;

export const selectCurrentPlan = (state: RootState) =>
  state.payments.currentPlan;

export const selectCurrentPlanLoading = (state: RootState) =>
  state.payments.currentPlanLoading;

export const selectCurrentPlanError = (state: RootState) =>
  state.payments.currentPlanError;

export const selectCreatePaymentLoading = (state: RootState) =>
  state.payments.createPaymentLoading;

export const selectCreatePaymentError = (state: RootState) =>
  state.payments.createPaymentError;

export const selectPaymentUsageLoading = (state: RootState) =>
  state.payments.paymentUsageLoading;

export const selectPaymentUsageError = (state: RootState) =>
  state.payments.paymentUsageError;

export const selectPaymentUsage = (state: RootState) =>
  state.payments.paymentUsage;

export const selectCancelSubscriptionLoading = (state: RootState) =>
  state.payments.cancelSubscriptionLoading;

export const selectCancelSubscriptionError = (state: RootState) =>
  state.payments.cancelSubscriptionError;

export const selectCustomerPortalLoading = (state: RootState) =>
  state.payments.customerPortalLoading;

export const selectCustomerPortalError = (state: RootState) =>
  state.payments.customerPortalError;

export const selectCheckoutUrl = (state: RootState) =>
  state.payments.checkoutUrl;

export const selectSelectedProduct = (state: RootState) =>
  state.payments.selectedProduct;
